import { initNativePredictiveResultClickTracking } from '@/shared/tracking/search-result-clicked';

/**
 * Binds native predictive-dropdown click tracking once per page lifetime.
 * Kept out of Autocomplete.vue on purpose: the header mounts multiple instances,
 * so a per-component bind tears the shared body listener down by click time.
 */

export const getNativePredictiveTerm = (): string | null => {
  // Read the live visible input (name="q") at click time; a Vue closure goes stale
  // across the multiple mounted instances.
  const value = Array.from(
    document.querySelectorAll<HTMLInputElement>(
      '.js-default-search-form input[name="q"]'
    )
  )
    .filter((el) => el.offsetParent !== null)
    .map((el) => el.value?.trim())
    .find((v) => Boolean(v));

  return value || null;
};

let nativePredictiveTrackingAttached = false;
let detachNativePredictiveTracking: (() => void) | null = null;

/** Test-only: reset the guard and detach the listener between specs. */
export const __resetNativePredictiveTrackingForTests = () => {
  detachNativePredictiveTracking?.();
  detachNativePredictiveTracking = null;
  nativePredictiveTrackingAttached = false;
};

export const attachNativePredictiveClickTracking = () => {
  if (nativePredictiveTrackingAttached) {
    return;
  }
  nativePredictiveTrackingAttached = true;
  detachNativePredictiveTracking = initNativePredictiveResultClickTracking(
    document.body,
    getNativePredictiveTerm
  );
};
